<template>
  <div :class="hidedata?'cData-c cData-cl':'cData-c'">
    <div class="cData">
      <p>全国道路日均运营次数</p>
      <div v-for="i in colorData" :style="{background:i}"></div>
      <p>
        <span>0</span>
        <span>54000</span>
        <span>108000</span>
        <span>162000</span>
      </p>
    </div>
    <div class="cData">
      <p>道路途径城市日均车次数</p>
      <div v-for="i in colorData1" :style="{background:i}"></div>
      <p>
        <span>0</span>
        <span>10166</span>
        <span>20232</span>
        <span>30500</span>
      </p>
    </div>
    <div class="cData">
      <p>城市日均车次</p>
      <div v-for="i in colorData" :style="{background:i}"></div>
      <p>
        <span>0</span>
        <span>54000</span>
        <span>108000</span>
        <span>162000</span>
      </p>
    </div>
  </div>
</template>
<script>
import common from '../assets/js/common.js'
export default {
  data() {
    return {
      colorData: common.colorData,
      colorData1: [
        '#680C94',
        '#773AC2',
        '#815BE3',
        '#4F3ACA',
        '#2D25BA',
        '#0911AA',
        '#0933BD',
        '#0B52CE',
        '#0D72E0',
        '#0D84EA',
        '#0EA6E7',
        '#0EB9BB',
        '#0EC4A0',
        '#0EDB69',
        '#0EEA44',
        '#0FF727',
        '#2BFF11',
        '#57FF0F',
        '#97FF0C',
        '#DAFF09',
        '#F5FF07',
        '#F5FF05',
        '#F7FF04',
        '#F8FF03',
        '#F9FF01',
        '#FAFD00',
        '#FBE700',
        '#FBDC00',
        '#FDCA00',
        '#FDBA00',
        '#FEA500',
        '#FE9400',
        '#FF7A00',
        '#FF7400',
        '#FF6800',
        '#FF5C00',
        '#FF5100',
        '#FF4A00',
        '#FF3D00',
        '#FF2D00',
        '#FF2900',
        '#FF1C00',
        '#FF0F00',
        '#FF0400',
        '#FC0000',
        '#F20000',
        '#EA0000',
        '#E10000',
        '#DA0000',
        '#D00000',
        '#C90000',
        '#C10000',
        '#B80000',
        '#B00000',
        '#A80000',
        '#9F0000',
        '#970000',
        '#8E0000',
        '#860000',
        '#7F0000'
      ]
    }
  },
  props: {
    hidedata: Boolean
  },
  watch: {},
  created() {},
  methods: {}
}
</script>
<style scoped>
.cData-c {
  position: absolute;
  z-index: 9000;
  left: 340px;
  bottom: 0px;
  -webkit-transition: left 0.8s;
  -moz-transition: left 0.8s;
  -o-transition: left 0.8s;
}
.cData {
  font-size: 10px;
  margin-bottom: 15px;
  color: #ffffff;
}
.cData-cl {
  left: 70px;
}
.cData p {
  margin: 0;
  opacity: 0.7;
  margin: 5px 0;
}
.cData p span {
  display: inline-block;
  width: 20%;
  text-align: center;
}
.cData p span:first-child {
  text-align: left;
}
.cData p span:nth-child(2),
.cData p span:nth-child(3) {
  width: 30%;
}
.cData p span:last-child {
  text-align: right;
}
.cData > div {
  width: 4px;
  height: 8px;
  display: inline-block;
}
</style>